import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { DoNotDisturb } from "@mui/icons-material";

import ViewProduct from "../components/ViewProduct";
import Alert from "../../../components/Alert";
import EmptyState from "../../../components/EmptyState";
import messages from "../../../assets/locale/messages";
import emptyBoxImg from "../../../assets/images/placeholders/emptyBox.svg";
import { ROUTE_PATHS } from "../../../utils/RoutesPaths";
import {
  PRODUCT_STATUS,
  PRODUCT_STATUS_IDS
} from "../../../utils/Constants";
import ApproveProduct from "../ApproveProduct";
import RejectProduct from "../RejectProduct";
import {
  productDetailsRequest,
  productDetailsResponse,
  productVersionDetailsRequest,
  productVersionDetailsResponse
} from "../../../store/Products/actions";
import { hasPermission, PERMISSIONS_IDS } from "../../../utils/Roles";

const ProductDetails = () => {
  const { id } = useParams();
  const location = useLocation();
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.loader.showLoader);
  const lang = useSelector((state) => state.locale.lang);
  const {
    products: { productDetails }
  } = messages[lang];
  const product = useSelector(
    (state) => state.products.productDetails
  );
  const productVersion = useSelector(
    (state) => state.products.productVersionDetails
  );

  const [isReviewPage, setIsReviewPage] = useState(null);
  const [productStatus, setProductStatus] = useState(false);
  const [productData, setProductData] = useState(null);

  useEffect(() => {
    if (location.pathname.includes(ROUTE_PATHS.productsRequests)) {
      setIsReviewPage(true);
    } else {
      setIsReviewPage(false);
    }
  }, [location]);

  useEffect(() => {
    if (id) {
      if (isReviewPage) {
        dispatch(productVersionDetailsRequest(id));
      } else if (isReviewPage === false) {
        dispatch(productDetailsRequest(id));
      }
    }
    return () => {
      dispatch(productDetailsResponse({}));
      dispatch(productVersionDetailsResponse({}));
    };
  }, [id, isReviewPage]);

  useEffect(() => {
    if (isReviewPage) {
      if (productVersion && Object.keys(productVersion).length) {
        setProductData(productVersion);
        setProductStatus(
          PRODUCT_STATUS_IDS.find(
            (status) => status.id === productVersion?.ProductStatusId
          ).value
        );
      }
    } else if (isReviewPage === false) {
      if (product && Object.keys(product).length) {
        setProductData(product);
        setProductStatus(
          PRODUCT_STATUS_IDS.find(
            (status) => status.id === product?.ProductStatusId
          ).value
        );
      }
    }
  }, [product, productVersion, isReviewPage]);

  const renderRejectionReason = () => (
    <div className="rejection-reason">
      <p className="fsize-16 fweight-500 text-error mb-1">
        {productData?.DefaultRejectionReasonMessage}
      </p>
      {productData?.RejectionReasonMessage && (
        <p className="text-light-grey mb-0">
          {productData?.RejectionReasonMessage}
        </p>
      )}
    </div>
  );

  return (
    <div className="product-details-container">
      {!isLoading && (
        <div>
          {productData && !!Object.keys(productData).length ? (
            <div>
              <div className="header-section mb-3 d-flex align-items-md-center align-items-start justify-content-between flex-column flex-md-row">
                <h3 className="fsize-22 fweight-700 title-color mb-3 mb-md-0">
                  {productDetails.productDetails}
                </h3>
                {hasPermission(
                  PERMISSIONS_IDS.product_request_accept_reject
                ) && (
                  <>
                    {isReviewPage &&
                      productStatus === PRODUCT_STATUS.pending && (
                        <div className="actions d-flex align-items-center">
                          <RejectProduct
                            productId={id}
                            productName={productData?.Name}
                          />
                          <ApproveProduct
                            productId={id}
                            productName={productData?.Name}
                          />
                        </div>
                      )}
                  </>
                )}
              </div>
              {productStatus === PRODUCT_STATUS.rejected &&
                (productData?.DefaultRejectionReasonMessage ||
                  productData?.RejectionReasonMessage) && (
                  <div className="rejection-reason-container mb-3">
                    <Alert
                      type="error"
                      content={renderRejectionReason()}
                      icon={<DoNotDisturb />}
                    />
                  </div>
                )}
              <div className="white-bg border-radius-10 p-4 mb-3">
                <ViewProduct productDetails={productData} />
              </div>
            </div>
          ) : (
            <EmptyState
              subTitle={productDetails.noProductFound}
              imgSrc={emptyBoxImg}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default ProductDetails;
